export default __webpack_public_path__ + "static/media/taxi-call.01456915.svg";